import { useAppDispatch } from "../../app/hooks";
import { useMessages2 } from "../../hooks/useLanguage";
import { closePopup } from "../../app/popup-slice";
import styles from './delete-cofirm-dialog.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { ButtonBar } from "../buttons";
import { configuratorActions } from "../../app/configurator-slice";


export const DeleteConfirmDialog = () => {

    const dispatch = useAppDispatch()
    const { messages } = useMessages2();

    const handleClose = () => {
        dispatch(closePopup())
    }

    const handleDelete = () => {
        dispatch(configuratorActions.deleteAllGroups());
        handleClose();
    }

    return (
        <div className={styles.dialogContainer}>
        
            <div className={styles.topContent}>
                <div className={styles.hiddenDiv}></div>
                <div className={styles.title}>
                    <h2>{messages?.sofa_invalid_title}</h2>
                </div>
                
                <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.closeButton}
                    onClick={handleClose}
                />
            </div>
                
            <div className={styles.infoContainer} >
                <div className={styles.textInfo}>
                    { messages?.build_remove_all_warning_description }
                </div>
                <div className={styles.directButton}>             
                    <ButtonBar>
                        <button onClick={handleClose} className={styles.button}>{messages?.exit_cancel}</button>
                        <button onClick={handleDelete} className={styles.button}>{messages?.exit_confirm}</button>
                    </ButtonBar>
                </div>
            </div> 

        </div>
    )
}